<div
  class="presaisie-panel"
  [class.presaisie-panel--collapsed]="collapsed">

  <div class="presaisie-panel__toggle">

    <div
      class="presaisie-panel__toggle-handle"
      (click)="togglePanel()">

      <div class="presaisie-panel__toggle-chevron">
        {{ collapsed ? '◀' : '▶' }}
      </div>

      <div class="presaisie-panel__toggle-label">
        Aide Saisie
      </div>

    </div>

  </div>

  <div
    class="presaisie-panel__content"
    *ngIf="!collapsed">

    <div class="presaisie-panel__header">

      <div class="presaisie-panel__title">
        {{ ligneSelectionnee?.nomCritere || 'Aide Saisie' }}
      </div>

      <button
        type="button"
        class="presaisie-panel__close-btn"
        (click)="togglePanel()">
        ✕
      </button>

    </div>

    <div class="presaisie-panel__body">

      <ng-container
        *ngTemplateOutlet="
          nodeList;
          context: {
            nodes: valeursPresaisie,
            level: 0,
            path: []
          }
        ">
      </ng-container>

    </div>


    <ng-template
      #nodeList
      let-nodes="nodes"
      let-level="level"
      let-path="path">

      <div
        *ngFor="let node of nodes"
        class="presaisie-node">

        <div
          class="presaisie-node__row"
          [class.presaisie-node__row--group]="node.children?.length > 0"
          [class.presaisie-node__row--value]="!node.children?.length"
          [style.padding-left.px]="8 + (level * 18)"

          (dblclick)="onValueDblClick(node, path, $event)">

          <div
            class="presaisie-node__chevron"
            (click)="toggleNode(node, $event)">

            <mat-icon *ngIf="node.children?.length">
              {{ node.expanded ? 'expand_more' : 'chevron_right' }}
            </mat-icon>

          </div>

          <div class="presaisie-node__label">
            {{ node.name }}
          </div>

          <div class="presaisie-node__actions">

      <button type="button" class="presaisie-node__action" title="Remplacer la valeur actuelle"
        [disabled]="!ligneSelectionnee" (click)="onActionClick('replace', node, path, $event)">
        <mat-icon>swap_horiz</mat-icon>
      </button>

      <button type="button" class="presaisie-node__action" title="Ajouter à la valeur actuelle"
        [disabled]="!ligneSelectionnee" (click)="onActionClick('concat', node, path, $event)">
        <mat-icon>add</mat-icon>
      </button>

    </div>

        </div>

        <div
          *ngIf="node.children?.length && node.expanded"
          class="presaisie-node__children">

          <ng-container
            *ngTemplateOutlet="
              nodeList;
              context: {
                nodes: node.children,
                level: level + 1,
                path: buildPath(path, node.name)
              }
            ">
          </ng-container>

        </div>

      </div>

    </ng-template>

  </div>

</div>
